<template>
  <div>
    <AlterFormLayout
      modalId="panel-economic-modal"
      formTitle="Painel econômico atualizado"
      cancelButtonText="Fechar"
      submitButtonText="Baixar demostrativo em PDF"
      :onSubmitEvent="downloadPdf"
      :disableValidation="true"
      :landscape="true"
    >
      <template #content>
        <pdf-viewer
          :landscape="true"
          :getDocumentHandler="getDocumentHandler"
          height="60vh"
        />
      </template>
    </AlterFormLayout>
  </div>
</template>

<script>
import PdfViewer from "../../../../components/pdf-viewer/PdfViewer.vue";
import AlterFormLayout from "../../../../layouts/AlterFormLayout.vue";
import { downloadFilePanelEconomic } from "../../../../services/pdf-download/pdf-download-services";
import { ExtensionFile } from "../../../../static-data/ExtensionFile";
import { anchorBase64Download } from "../../../../utils/anchor-base64-download/anchor-base64-download";

export default {
  data() {
    return {
      downloadedFile: null,
      fileName: null,
      fileUrl: null,
    };
  },
  components: {
    AlterFormLayout,
    PdfViewer,
  },
  methods: {
    downloadPdf() {
      if (!this.downloadedFile) return;
      anchorBase64Download(
        this.$store.getters.isApp,
        "application/pdf",
        this.fileName,
        this.downloadedFile
      );
    },
    async getDocumentHandler() {
      const download = await this.downloadFile();
      this.downloadedFile = download;
      const binaryString = atob(download);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    },
    async downloadFile() {
      try {
        const response = await downloadFilePanelEconomic(1, ExtensionFile.PDF);
        this.fileUrl = response.fileUrl;
        this.fileName = response.fileName;
        return response.document;
      } catch (error) {
        console.error("Error on function downloadFile:", error);
      }
    },
  },
};
</script>
